module.exports = __webpack_public_path__ + "img/coin1.12be8bc2.png";